// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdministrativeAreasController from "./administrative_areas_controller"
application.register("administrative-areas", AdministrativeAreasController)

import AjaxSubmitterController from "./ajax_submitter_controller"
application.register("ajax-submitter", AjaxSubmitterController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import CheckboxLimitController from "./checkbox_limit_controller"
application.register("checkbox-limit", CheckboxLimitController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DependentSelectController from "./dependent_select_controller"
application.register("dependent-select", DependentSelectController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FieldToggleController from "./field_toggle_controller"
application.register("field-toggle", FieldToggleController)

import FocusElementController from "./focus_element_controller"
application.register("focus-element", FocusElementController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import ListboxController from "./listbox_controller"
application.register("listbox", ListboxController)

import MediaPlaybackController from "./media_playback_controller"
application.register("media-playback", MediaPlaybackController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PopupWindowController from "./popup_window_controller"
application.register("popup-window", PopupWindowController)

import PushStateController from "./push_state_controller"
application.register("push-state", PushStateController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SortableCharsController from "./sortable_chars_controller"
application.register("sortable-chars", SortableCharsController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableNumbersController from "./sortable_numbers_controller"
application.register("sortable-numbers", SortableNumbersController)

import SortablePositionsController from "./sortable_positions_controller"
application.register("sortable-positions", SortablePositionsController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import TextCounterController from "./text_counter_controller"
application.register("text-counter", TextCounterController)

import ToggleActiveController from "./toggle_active_controller"
application.register("toggle-active", ToggleActiveController)

import VideoLoadController from "./video_load_controller"
application.register("video-load", VideoLoadController)

import VideoSearchController from "./video_search_controller"
application.register("video-search", VideoSearchController)
